(function () {
  const ITEMS_PER_PAGE = 12;

  const state = {
    searchHeader: '',
    currentPage: 1,
  };

  const els = {
    productGrid: document.getElementById('product-grid'),
    pagination: document.getElementById('pagination'),
    searchHeader: document.getElementById('search-header'),
  };

  if (!els.productGrid || !els.pagination) {
    return;
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value);
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function parseProducts() {
    const raw = document.getElementById('shopify-products-data');
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw.textContent || '[]');
      return parsed
        .filter((item) => item?.id && item?.handle && item?.name)
        .map((item, index) => ({
          id: item.id,
          handle: item.handle,
          name: item.name,
          price: Number(item.price || 0),
          image: item.image || '',
          position: index,
        }));
    } catch {
      return [];
    }
  }

  const shopifyProducts = parseProducts();

  function getVisibleProducts() {
    const term = normalizeText(state.searchHeader);
    const filtered = term
      ? shopifyProducts.filter((product) => normalizeText(product.name).includes(term))
      : shopifyProducts.slice();

    filtered.sort((a, b) => a.position - b.position);
    return filtered;
  }

  function renderProductCard(product) {
    const imageMarkup = product.image
      ? '<img src="' + product.image + '" alt="' + product.name + '" class="product-card__image" loading="lazy">'
      : '<div class="product-card__image product-card__image--placeholder">Sin imagen</div>';

    return (
      '<a href="/products/' +
      product.handle +
      '" class="product-card">' +
      '<div class="product-card__image-wrap">' +
      imageMarkup +
      '</div>' +
      '<div class="product-card__info">' +
      '<h3 class="product-card__name">' +
      product.name +
      '</h3>' +
      '<p class="product-card__price">' +
      formatPrice(product.price) +
      '</p>' +
      '</div>' +
      '</a>'
    );
  }

  function getTotalPages(total) {
    return Math.max(1, Math.ceil(total / ITEMS_PER_PAGE));
  }

  function renderPagination(totalPages) {
    if (totalPages <= 1) {
      els.pagination.innerHTML = '';
      return;
    }

    const current = state.currentPage;
    const buttons = [];

    buttons.push(
      '<button type="button" class="pagination__btn" data-page="prev" ' +
        (current === 1 ? 'disabled' : '') +
        ' aria-label="Página anterior">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>' +
      '</button>'
    );

    for (let i = 1; i <= totalPages; i += 1) {
      buttons.push(
        '<button type="button" class="pagination__btn ' +
          (i === current ? 'pagination__btn--active' : '') +
          '" data-page="' +
          i +
          '">' +
          i +
        '</button>'
      );
    }

    buttons.push(
      '<button type="button" class="pagination__btn" data-page="next" ' +
        (current === totalPages ? 'disabled' : '') +
        ' aria-label="Página siguiente">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>' +
      '</button>'
    );

    els.pagination.innerHTML = buttons.join('');
  }

  function render() {
    const visible = getVisibleProducts();
    const totalPages = getTotalPages(visible.length);

    if (state.currentPage > totalPages) {
      state.currentPage = totalPages;
    }

    const start = (state.currentPage - 1) * ITEMS_PER_PAGE;
    const pageItems = visible.slice(start, start + ITEMS_PER_PAGE);

    if (pageItems.length === 0) {
      els.productGrid.innerHTML =
        '<div class="empty-state">' +
          '<p>No encontramos productos con ese nombre.</p>' +
        '</div>';
    } else {
      els.productGrid.innerHTML = pageItems.map(renderProductCard).join('');
    }

    renderPagination(totalPages);
  }

  function initSearch() {
    if (!els.searchHeader) return;

    let headerTimeout;
    els.searchHeader.addEventListener('input', (event) => {
      clearTimeout(headerTimeout);
      headerTimeout = setTimeout(() => {
        state.searchHeader = event.target.value;
        state.currentPage = 1;
        render();
      }, 220);
    });
  }

  function initPagination() {
    els.pagination.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-page]');
      if (!btn || btn.disabled) return;

      const visible = getVisibleProducts();
      const totalPages = getTotalPages(visible.length);
      const page = btn.dataset.page;

      if (page === 'prev') state.currentPage = Math.max(1, state.currentPage - 1);
      else if (page === 'next') state.currentPage = Math.min(totalPages, state.currentPage + 1);
      else state.currentPage = Number(page);

      render();
      const catalog = document.getElementById('catalogo');
      if (catalog) catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initHeroCTA() {
    const btnCatalog = document.getElementById('btn-view-catalog');
    const btnNow = document.getElementById('btn-shop-now');
    const catalog = document.getElementById('catalogo');

    if (btnCatalog && catalog) {
      btnCatalog.addEventListener('click', () => catalog.scrollIntoView({ behavior: 'smooth' }));
    }

    if (btnNow && catalog) {
      btnNow.addEventListener('click', () => catalog.scrollIntoView({ behavior: 'smooth' }));
    }
  }

  function initCartButton() {
    const cartBtn = document.getElementById('cart-btn');
    if (!cartBtn) return;

    cartBtn.addEventListener('click', () => {
      globalThis.location.href = '/cart';
    });
  }

  function init() {
    initSearch();
    initPagination();
    initHeroCTA();
    initCartButton();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
